import { SwiperBenefit } from "../plugin/SwiperBenefit";

export function Benefit() {
  return (
    <>
      <section className="main-sec main-benefit">
        <h2 className="section-title invisible">메인 혜택 배너</h2>
        <SwiperBenefit />
      </section>
    </>
  );
} //////// Benefit 컴포넌트 ///////
